import getUID from '@jetbrains/ring-ui/components/global/get-uid'
import {useMemo} from 'react'

export default function useUID(base: string): string {
  return useMemo(
    () =>
      getUID(
        base
          .toLowerCase()
          .replace(/\s/g, '-')
          .replace(/[^a-z0-9_-]/gi, ''),
      ),
    [base],
  )
}
